import { Button } from "@flat-ui";
import { Stack } from "@mui-wrapper";

interface Props {
  /** Whether every option is selected already, so that there is nothing left to select */
  isEverythingSelected: boolean;

  /** Whether nothing is selected, so that there is nothing to deselect */
  isNothingSelected: boolean;

  /** Called to select every option */
  onSelectAll: () => void;

  /** Called to drop the whole selection */
  onDeselectAll: () => void;
}

/**
 * Both actions stay in place and are only disabled, so that activating one neither drops the
 * keyboard focus nor slides the other one under the pointer that just clicked.
 *
 * @returns the actions that select every option at once or deselect them all again
 */
export function BulkActions({
  isEverythingSelected,
  isNothingSelected,
  onSelectAll,
  onDeselectAll,
}: Props): React.JSX.Element {
  return (
    <Stack
      direction="row"
      sx={{
        justifyContent: "space-between",
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <Button
        variant="ghost"
        disabled={isEverythingSelected}
        onClick={onSelectAll}
      >
        Select All
      </Button>
      <Button
        variant="ghost"
        disabled={isNothingSelected}
        onClick={onDeselectAll}
      >
        Deselect All
      </Button>
    </Stack>
  );
}
